import { render, staticRenderFns } from "./FreepageIndex.vue?vue&type=template&id=3e4a35a9&"
import script from "./FreepageIndex.vue?vue&type=script&lang=js&"
export * from "./FreepageIndex.vue?vue&type=script&lang=js&"
import style0 from "./FreepageIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports